import React from 'react';
import { Globe } from 'lucide-react';

// Trustpilot logo URL (SVG)
const TRUSTPILOT_LOGO = '/images/trustpilot-logo.svg';

const Footer = () => {
  const footerLinks = {
    about: [
      { label: "À propos", href: "#" },
      { label: "Emplois", href: "#" },
      { label: "Contact", href: "#" },
      { label: "Blog", href: "#" },
      { label: "Comment fonctionne Trustpilot", href: "#" },
      { label: "Transparence", href: "#" },
      { label: "Investisseurs", href: "#" },
      { label: "Presse", href: "#" },
    ],
    community: [
      { label: "Centre de confiance", href: "#" },
      { label: "Centre d'assistance", href: "#" },
      { label: "Connexion", href: "#" },
      { label: "Inscription", href: "#" },
      { label: "Créateurs de Chrome", href: "#" },
    ],
    businesses: [
      { label: "Trustpilot Business", href: "#" },
      { label: "Produits", href: "#" },
      { label: "Forfaits & Tarifs", href: "#" },
      { label: "Connexion entreprise", href: "#" },
      { label: "Blog entreprises", href: "#" },
    ],
  };

  return (
    <footer className="bg-[#1a1a1a] text-white py-12">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Logo & Language */}
          <div>
            <img 
              src={TRUSTPILOT_LOGO} 
              alt="Trustpilot" 
              className="h-8 w-auto mb-6"
            />

            <button className="flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors">
              <Globe className="w-4 h-4" />
              <span>Français (FR)</span>
            </button>
          </div>

          {/* About Links */}
          <div>
            <h4 className="font-semibold mb-4">À propos</h4>
            <ul className="space-y-2">
              {footerLinks.about.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="text-sm text-gray-400 hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Community Links */}
          <div>
            <h4 className="font-semibold mb-4">Communauté</h4>
            <ul className="space-y-2">
              {footerLinks.community.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="text-sm text-gray-400 hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Businesses Links */}
          <div>
            <h4 className="font-semibold mb-4">Entreprises</h4>
            <ul className="space-y-2">
              {footerLinks.businesses.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="text-sm text-gray-400 hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-gray-400">
              <a href="#" className="hover:text-white transition-colors">Conditions d'utilisation</a>
              <a href="#" className="hover:text-white transition-colors">Politique de confidentialité</a>
              <a href="#" className="hover:text-white transition-colors">Politique relative aux cookies</a>
              <button className="hover:text-white transition-colors">Gérer mes cookies</button>
            </div>
            <p className="text-sm text-gray-500">
              © 2026 Trustpilot A/S. Tous droits réservés.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
